export default {"src":"/_next/static/media/ic-tag.db8c58b4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};